module.exports = __webpack_public_path__ + "public/files/img/stc.3111039d.svg";